import { useMemo } from "react";
import { getUserCountryCode } from "../utils/countriesTexts";

export const useUserCountryCode = () => {
  return useMemo(() => getUserCountryCode() || "", []); 
}